module.exports = __webpack_public_path__ + "static/media/visas2.86c1ff40.PNG";